// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uR5c","placeholdersHeader":"styles_placeholdersHeader__3WDyg","editorStyle":"styles_editorStyle__1b3vm","placeholdersBox":"styles_placeholdersBox__208bc"};